import * as Slate from "../slate";
function introspectNodes(nodes, target, pluginControls) {
  return nodes.flatMap(introspectNode);
  function introspectNode(descendant) {
    if (Slate.Element.isElement(descendant)) {
      return [
        ...introspectElement(descendant),
        ...descendant.children.flatMap(introspectNode)
      ];
    }
    if (Slate.Text.isText(descendant)) {
      return introspectText(descendant);
    }
    return [];
  }
  function introspectElement(descendant) {
    return pluginControls.flatMap(
      (control) => control.getElementValue ? control.definition.introspect(
        control.getElementValue(descendant),
        target
      ) : []
    );
  }
  function introspectText(text) {
    return pluginControls.flatMap(
      (control) => control.getLeafValue ? control.definition.introspect(control.getLeafValue(text), target) : []
    );
  }
}
export {
  introspectNodes
};
//# sourceMappingURL=introspection.js.map